import Header from "../../components/Header";
import ContentWrapper from "../../components/ContentWrapper";
import BoxWelcome from "./_components/BoxWelcome";

const Welcome = () => (
  <>
    <div className="px-[10px] pt-[5px]">
      <Header />
    </div>
    <ContentWrapper>
      <BoxWelcome />
    </ContentWrapper>
  </>
);

export default Welcome;
